import { useSyncExternalStore } from 'react';

let current: { id: number; msg: string } | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();
const emit = () => {
  for (const l of listeners) l();
};

/** Show the design's dark top toast for 2.4 s. */
export function toast(msg: string) {
  current = { id: Date.now(), msg };
  emit();
  clearTimeout(timer);
  timer = setTimeout(() => {
    current = null;
    emit();
  }, 2400);
}

export function useToast() {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
